import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes, RouteParamsTypes, Modules, NonAuthRoutes
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import Dashboard from '../modules/home/dashboard/root';

const Home: React.FC = () => {
  return (
    <Routes>
      <Route path={AuthRoutes.dashboard}>
        <Route path={AuthRoutes.dashboard + RouteParamsTypes.blank} element={<ProtectedRoute component={Dashboard} />} />
      </Route>
      <Route path={RouteParamsTypes.blank} element={<Navigate replace to={{ pathname: Modules.home + AuthRoutes.dashboard }} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Home;
